module.exports = __webpack_public_path__ + "static/media/Icons_IS_call_transfer_white.7b0ebb12.svg";